import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LogoFull } from "@/components/Logo";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const savedPath = sessionStorage.getItem("kandula-return-to") || "/";
    const returnTo = savedPath.startsWith("/") && !savedPath.startsWith("//") && !savedPath.includes("\\") ? savedPath : "/";
    sessionStorage.removeItem("kandula-return-to");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    window.history.replaceState(null, "", window.location.pathname);
    axios
      .post(`${API}/auth/session`, { session_id: sessionId })
      .then((r) => {
        setUser(r.data);
        window.history.replaceState(null, "", returnTo);
        navigate(returnTo, { replace: true, state: { user: r.data } });
      })
      .catch(() => setError("We couldn't complete your sign-in. Please try again."));
  }, [location.hash, navigate, setUser]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-cream font-body" data-testid="auth-callback-page">
      <LogoFull />
      {error ? (
        <div className="text-center" data-testid="auth-callback-error">
          <p className="text-sm text-terracotta">{error}</p>
          <button onClick={() => navigate("/", { replace: true })} className="mt-3 text-sm font-semibold text-ragi underline" data-testid="auth-callback-home">Back to shop</button>
        </div>
      ) : (
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground" data-testid="auth-callback-status">Signing you in…</p>
      )}
    </div>
  );
}
